/**
 * Barrel for the Mapbox provider. Exports the `MapConnector` + the
 * `GeocodeConnector` so the resolver in `shared/maps/index.ts` can hand them
 * out without knowing about per-component files.
 */

import type { MapConnector } from '../../types';
import { MapboxMapView } from './MapboxMapView';
import { MapboxMarker } from './MapboxMarker';
import { MapboxAutocomplete } from './MapboxAutocomplete';
import { MapboxPolyline } from './MapboxPolyline';

export const mapboxMapsConnector: MapConnector = {
  name: 'mapbox',
  MapView: MapboxMapView,
  Marker: MapboxMarker,
  Autocomplete: MapboxAutocomplete,
  Polyline: MapboxPolyline,
};

export { mapboxGeocodeConnector } from './mapboxGeocode';
